var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mg-report-title"},[_c('h4',[_c('span',{staticClass:"badge badge-secondary"},[_vm._v(_vm._s(_vm.type))])]),_c('h1',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }